/*jslint vars: true, plusplus: true, devel: true, nomen: true, indent: 4, maxerr: 50 */
(function(){
	'use strict';

jQuery( document ).ready(function() {

	//**** Toggle mobile menu ****//

    jQuery('.hamburger-wrapper').click(function() {
    	jQuery('body').toggleClass('mobile-nav-open');
    	jQuery('.main-menu').slideToggle(300);
    });


    //**** Toggle articles ****//

    function mobileCheck() {
    	var mobileBreakpoint = 950;
    	var windowWidth = jQuery(window).width();

		if (windowWidth < mobileBreakpoint) {
	  		jQuery( "body" ).addClass("mobile-breakpoint");
	  		jQuery( "body" ).removeClass("desktop-breakpoint");
	  	} else {
	  		jQuery( "body" ).addClass("desktop-breakpoint");
	  		jQuery( "body" ).removeClass("mobile-breakpoint");	  		
	  	}
    }

    mobileCheck();

    jQuery( window ).resize(function() {
    	mobileCheck();
	});

    $("a[rel^='prettyPhoto']").prettyPhoto({
            animation_speed: 'fast', /* fast/slow/normal */
            slideshow: false, /* false OR interval time in ms */
            autoplay_slideshow: false, /* true/false */
            opacity: 0.80, /* Value between 0 and 1 */
            show_title: false, /* true/false */
            allow_resize: true, /* Resize the photos bigger than viewport. true/false */
            counter_separator_label: ' van ', /* The separator for the gallery counter 1 "of" 2 */
            theme: 'dark_square', /* light_rounded / dark_rounded / light_square / dark_square / facebook */
            horizontal_padding: 0, /* The padding on each side of the picture */
            hideflash: true, /* Hides all the flash object on a page, set to TRUE if flash appears over prettyPhoto */
            deeplinking: true, /* Allow prettyPhoto to update the url to enable deeplinking. */
            overlay_gallery: false, /* If set to true, a gallery will overlay the fullscreen image on mouse over */
            keyboard_shortcuts: true, /* Set to false if you open forms inside prettyPhoto */
            image_markup: '<img id="fullResImage" src="{path}" />',
            custom_markup: '',
            social_tools: false /* html or false to disable */
        });

});

})(); // END OF USE STRICT FUNCTION